import styled from 'styled-components';
import {
  space,
  layout,
  background,
  border,
  position,
  typography,
  flexbox,
  grid,
} from 'styled-system';
import { Box } from '@rebass/grid';

import { fixPropWarnings } from '../../utils/fixPropWarnings';

interface GridContainerProps {
  fluid?: boolean;
}

const GridContainer = styled(Box).withConfig(fixPropWarnings('fluid'))<GridContainerProps>`
  margin: 0 auto;
  width: ${(props) => (props.fluid ? '100%' : 'calc(100% - 30px)')};
  max-width: 1280px;
  @media only screen and (min-width: 679px) {
    width: ${(props) => (props.fluid ? '100%' : 'calc(100% - 60px)')};
  }
  /* Min-width 1340 because we break at 1280, so 1280 + 60px and this is our grid gutters */
  @media only screen and (min-width: 1340px) {
    width: 100%;
  }
  ${space};
  ${layout};
  ${background};
  ${typography};
  ${border};
  ${position};
  ${flexbox};
  ${grid}
`;

export default GridContainer;
